module.exports = __webpack_public_path__ + "static/media/2025_schriftzug_hoch.0bd9c742.png";